// Copyright (c) 2016 Deere & Company

import actions from '../action-list';
import {mapFormValidation} from '../services/claim-validation-helper';

export const updateResponsibleAccountsDropDown = (accountId, dealerCollection) =>
    dispatch => {

        dispatch({
            accountId,
            dealerCollection,
            type: actions.UPDATE_CLAIM_JDP_RESPONSIBLE_ACCOUNTS
        });

    };

export const updateJdpClaimProperty = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_JDP_PROPERTY,
    value
});

export const updateJdpClaimType = (jdpType, collection) => ({
    collection,
    jdpType,
    type: actions.UPDATE_CLAIM_JDP_TYPE
});

export const updateReasonForReturnDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_JDP_REASON_FOR_RETURN
});

export const updateCustomerResolutionDropDown = (key, statusCollection) => ({
    key,
    statusCollection,
    type: actions.UPDATE_CLAIM_JDP_CUSTOMER_RESOLUTION
});

export const updateJdpClaimFailurePart = partNumber => ({
    partNumber,
    type: actions.UPDATE_CLAIM_JDP_FAILURE_PART
});

export const updateJdpClaimInputOnBlur = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_JDP_FORM_VALIDATION,
    validity: mapFormValidation(property, value)
});

export const resetJdpClaim = () => ({
    type: actions.RESET_CLAIM_JDP
});

export const updateJdpClaimWorkOrderOne = workOrder => ({
    type: actions.UPDATE_CLAIM_JDP_WORK_ORDER_ONE,
    workOrder
});

export const updateJdpClaimRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_JDP_REPAIR_NUMBER
});

export const resetJdpProductDetails = () => ({
    type: actions.RESET_CLAIM_JDP_PRODUCT_DETAILS
});

export const updateStickyHeaderVisibility = status =>
    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_JDP_STICKY_HEADER_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-creators/claim-details.js